// Environment configuration template
// Copy this to .env.local and fill in your actual values

export const environment = {
  // AWS Cognito Configuration
  awsUserPoolId: import.meta.env.VITE_AWS_USER_POOL_ID || "",
  awsCognitoRegion: import.meta.env.VITE_AWS_COGNITO_REGION || "us-east-1",
  awsUserPoolClientId: import.meta.env.VITE_AWS_USER_POOL_CLIENT_ID || "",
  cognitoDomain: import.meta.env.VITE_AWS_COGNITO_DOMAIN || "",
  // Identity pool not needed for JWT authentication

  // Backend Gateway Configuration
  backendGatewayUrl: import.meta.env.VITE_BACKEND_GATEWAY_URL || "http://localhost:3000",
  backendGatewayHost: import.meta.env.VITE_BACKEND_GATEWAY_HOST || "localhost",
  backendGatewayPath: import.meta.env.VITE_BACKEND_GATEWAY_PATH || "/api",
  backendGatewayGraphqlPath: import.meta.env.VITE_BACKEND_GATEWAY_GRAPHQL_PATH || "/graphql",
  awsRegion: import.meta.env.VITE_AWS_REGION || "us-east-1",

  // AppSync Configuration
  appsyncHttpEndpoint: import.meta.env.VITE_APPSYNC_HTTP_ENDPOINT || "",
  appsyncRealtimeEndpoint: import.meta.env.VITE_APPSYNC_REALTIME_ENDPOINT || "",
  appsyncApiId: import.meta.env.VITE_APPSYNC_API_ID || "",
  appsyncRegion: import.meta.env.VITE_APPSYNC_REGION || "us-east-1",
  appsyncCustomDomainUrl: import.meta.env.VITE_APPSYNC_CUSTOM_DOMAIN_URL || "",
};

// Validation function to check if required environment variables are set
export const validateEnvironment = () => {
  const required = ["awsUserPoolId", "awsCognitoRegion", "awsUserPoolClientId", "cognitoDomain"];

  const missing = required.filter((key) => !environment[key as keyof typeof environment]);

  if (missing.length > 0) {
    console.warn("Missing required environment variables:", missing);
    return false;
  }

  return true;
};

// Validation function for AppSync environment variables
export const validateAppSyncEnvironment = () => {
  const required = ["appsyncHttpEndpoint", "appsyncApiId", "appsyncRegion"];

  const missing = required.filter((key) => !environment[key as keyof typeof environment]);

  if (missing.length > 0) {
    console.warn("Missing required AppSync environment variables:", missing);
    return false;
  }

  return true;
};
